<template>
  <div v-if="clientWidth < 768">
    <div class="header">
      <img src="https://staticdn.ht-s.cn/se/ciif/2024/logo.png" alt="" />
    </div>
    <div class="wrap">
      <div class="scan1 scan" v-if="status1">
        <div class="scan_text">
          您好！您已成功获取施耐德电气<br />
          工博会兑奖管理员权限！
        </div>
        <img src="https://staticdn.ht-s.cn/se/ciif/2024/scanCode/img_code.png" @click="scanCodeQR" alt="" />
      </div>
      <div class="scan2 scan" v-if="status2">
        <img src="https://staticdn.ht-s.cn/se/ciif/2024/scanCode/img_nohave.png" alt="" />
        <div class="scan_text">
          您好！<br />
          该用户未兑奖，请发放奖品！
        </div>
        <div class="scan_btn">
          <div class="btn1 btn" @click="handleConfirm">确认兑换</div>
          <div class="btn2 btn" @click="scanCodeQR">继续扫码</div>
        </div>
      </div>
      <div class="scan3 scan" v-if="status3">
        <img src="https://staticdn.ht-s.cn/se/ciif/2024/scanCode/img_have.png" alt="" />
        <div class="scan_text">
          您好！<br />
          该用户已兑奖！
        </div>
        <div class="scan_btn">
          <div class="btn1 btn scan_opacity">确认兑换</div>
          <div class="btn2 btn" @click="scanCodeQR">继续扫码</div>
        </div>
      </div>
      <div class="scan4 scan" v-if="status4">
        <img class="scan4_img" src="https://staticdn.ht-s.cn/se/ciif/2024/scanCode/img_success.png" alt="" />
        <div class="scan_text">兑奖成功，奖品已发放</div>
        <div class="scan_btn">
          <div class="btn3 btn" @click="scanCodeQR">
            <img src="https://staticdn.ht-s.cn/se/ciif/2024/scanCode/icon_scan.png" alt="" />
            继续扫码
          </div>
        </div>
      </div>
    </div>
    <div class="footer">©{{ Year }} 版权所有 施耐德电气(中国)有限公司</div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { GetExchangePrize, ExchangePrize, GetUserLogs } from "../../api/index.js";
let nowDate = new Date();
export default {
  data() {
    return {
      Year: nowDate.getFullYear(),
      openid: "",
      pids: "",
      status1: false,
      status2: false,
      status3: false,
      status4: false,
    };
  },
  components: {},
  mounted() {
    GetUserLogs({
      visitName: '页面访问-扫码领奖',
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 11058
    })
    if (this.$store.state.clientWidth > 768) {
      alert("请使用手机端访问");
    }
    this.$toast.loading({ message: "loading", loadingType: "spinner", duration: 1000 });
    setTimeout(() => {
      let params = this.$route.query;
      if (!this.$store.state.islogin) {
        this.$router.push({
          path: "/Home/Index",
          query: {
            track: params.track ? params.track : "",
            utm_source: params.utm_source ? params.utm_source : "",
            utm_medium: params.utm_medium ? params.utm_medium : "",
            utm_campaign: params.utm_campaign ? params.utm_campaign : "",
            utm_content: params.utm_content ? params.utm_content : "",
            se_sr: params.se_sr ? params.se_sr : "",
            se_md: params.se_md ? params.se_md : "",
            se_ct: params.se_ct ? params.se_ct : "",
          },
        });
      }
      if (params.openid) {
        this.openid = params.openid;
        // this.pids = params.pids
        this.GetExchangePrize(params.openid);
      } else {
        this.status1 = true;
      }
    }, 1000);
  },
  methods: {
    GetExchangePrize(openid) {
      GetExchangePrize(openid).then((res) => {
        if (res.Status == 1) {
          this.status2 = true;
          this.pids = res.Data;
        } else if (res.Status == 4) {
          this.status3 = true;
        } else {
          alert(res.Message);
        }
      });
    },
    handleConfirm() {
      ExchangePrize(this.openid, this.pids).then((res) => {
        if (res.Status == 1) {
          this.status2 = false;
          this.status4 = true;
        } else {
          alert(res.Message);
        }
      });
    },
    scanCodeQR() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") !== -1;
      if (!isWeixin) {
        alert("请用微信打开连接，才可使用扫一扫");
        return false;
      }

      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          // alert(result);
          window.location.href = result;
        },
        error: function (res) {
          if (res.errMsg.indexOf("function_not_exist") > 0) {
            alert("当前版本过低，请进行升级");
          }
        },
      });
    },
  },
  watch: {},
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    islogin() {
      return this.$store.state.islogin;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>